module.exports = __webpack_public_path__ + "static/media/375.24da8920.png";